import React from "react";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import autoBind from "react-autobind";
import _ from "lodash";

import { getUrlForValue } from "../../actions/drive";
import { getSelectedActivityId } from "../../actions/playerActions";
import PlayerCheckbox from "./PlayerCheckbox";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";
/*
	 Generic read-only version of a player component 
 */
class PlayerMultiChoice extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
	}

	render() {
		if (this.props.showMode !== true) {
			if (this.props.readOnly) {
				return this.renderReadOnly();
			} else {
				return this.renderEditable();
			}
		} else {
			return this.renderShowMode();
		}
	}

	onClick(event, value, label) {
		const { item } = this.props;
		const { suppressAudioValue } = item;
		let newArray = item.value.slice();

		if (event.target.checked) {
			newArray.push({
				value: value,
				label: label
			});
			if (!suppressAudioValue) {
				SyntheticVoiceApi.stop();
				SyntheticVoiceApi.speak(label);
			}
		} else {
			newArray = this.removeItem(newArray, value);
			if (!suppressAudioValue) {
				SyntheticVoiceApi.stop();
				SyntheticVoiceApi.speak("Removed " + label);
			}
		}



		if (this.props.onChange) { this.props.onChange(newArray); }
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.props.item.value.slice()); }
	}

	removeItem(arr, value) {
		let result = [];

		_.forEach(arr, item => {
			if (item.value !== value) {
				result.push(item);
			}
		});

		return result;
	}


	isChecked(arr, value) {
		let result = false;

		if (arr && _.isArray(arr)) {
			_.forEach(arr, item => {
				if (item.value === value) {
					result = true;
				}
			});
		}
		return result;
	}

	renderReadOnly() {
		let self = this;
		const { item, getLabelsReadOnly, getImage, getVideo, getPdf } = this.props;

		let idPostfix = this.props.getActivityItemPath("-");

		const rows = item.choiceItems.map((choiceItem, i) => {
			let check;

			//add dynamic styles if present
			if (choiceItem.properties && choiceItem.properties !== "") {
				let properties = choiceItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(choiceItem, propertiesObject);
			}

			if (choiceItem.style) {
				choiceItem.style.justifyContent = choiceItem.style.textAlign === "right" ? "flex-end" : "flex-start";
			}

			let checkboxSize = "24px";

			if (self.isChecked(item.value, choiceItem.value)) {
				check = <FontAwesomeIcon fixedWidth={true} style={{ fontSize: checkboxSize, margin: 10 }} icon="check-square" />;
			} else {
				check = <FontAwesomeIcon fixedWidth={true} style={{ fontSize: checkboxSize, margin: "10px 10px 10px 8px" }} icon="square" />;
			}

			let style = { display: "flex", flexDirection: "row", width: "100%", alignItems: "center" };

			const idKey = "player-check-item-" + i + "-" + idPostfix;
			return (<div key={idKey} style={_.merge(style, choiceItem.style)}>
				{check}
				<div>{choiceItem.label}</div>
			</div>);
		});

		let rowsContainer;

		if (item.backgroundImage) {
			const url = getUrlForValue(item.backgroundImage, getSelectedActivityId());
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
				<div style={{ backgroundImage: `url(${url})` }} className="player-item-background-image">
					{rows}
				</div>
			</div>;

		} else {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
				{rows}
			</div>;
		}
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflow: "none" }}>
					{getLabelsReadOnly()}
					{getImage()}
					{getVideo()}
					{getPdf()}
					{rowsContainer}
				</div>
			</div>
		);
	}

	renderEditable() {
		const self = this;

		const { item, getLabels, getImage, getVideo, getPdf, disabled } = this.props;

		let idPostfix = this.props.getActivityItemPath("-");
		let rows = item.choiceItems.map((choiceItem, idx) => {
			const idKey = "player-check-item-" + idx + "-" + idPostfix;
			let checked = self.isChecked(item.value, choiceItem.value);

			//add dynamic styles if present
			if (choiceItem.properties && choiceItem.properties !== "") {
				let properties = choiceItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(choiceItem, propertiesObject);
			}
			let inputSize = 30; // use default
			if (choiceItem.style) {
				choiceItem.style.justifyContent = choiceItem.style.textAlign === "right" ? "flex-end" : "flex-start";
				inputSize = choiceItem.style.inputSize ? choiceItem.style.inputSize : 30;
			}

			return (
				<PlayerCheckbox size={inputSize} key={idKey} id={idKey} checked={checked} onClick={(e) => self.onClick(e, choiceItem.value, choiceItem.label)} label={choiceItem.label} disabled={disabled} style={choiceItem.style} />
			);
		});

		let rowsContainer;

		if (item.backgroundImage) {
			const url = getUrlForValue(item.backgroundImage, getSelectedActivityId());
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "12px", alignItems: "center" }}>
				<div style={{ backgroundImage: `url(${url})` }} className="player-item-background-image">
					{rows}
				</div>
			</div>;

		} else {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "12px" }}>
				{rows}
			</div>;
		}
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					{getLabels()}
					{getImage()}
					{getVideo()}
					{getPdf()}
					{rowsContainer}
					{!disabled && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>
		);
	}

	renderShowMode() {
		const self = this;

		const { item, getLabelsShowMode, disabled, showModeTextAlign: _showModeTextAlign } = this.props;

		// // console.log("Deternine background image", this.props);
		let backgroundImage;
		if (item.backgroundImage) {
			const url = getUrlForValue(item.backgroundImage, getSelectedActivityId());
			backgroundImage = `url('${url}')`;
		}

		let mediaItem;

		let image = this.props.getImageShowMode();
		let video = this.props.getVideoShowMode(this.showModeVideoRef);

		if (image) {
			mediaItem = image;
		} else if (video) {
			mediaItem = video;
		}

		const hasTextContent = (item.label1 && !_.isEmpty(item.label1)) || (item.label2 && !_.isEmpty(item.label2));

		const { showModeTextAlign } = item;

		let align = "";
		if (showModeTextAlign || _showModeTextAlign) {
			const targetShowModeTextAlign = showModeTextAlign ? showModeTextAlign : _showModeTextAlign;
			align = " " + targetShowModeTextAlign.split("-").join(" ");
		}


		let idPostfix = this.props.getActivityItemPath("-");
		let rows = item.choiceItems.map((choiceItem, idx) => {
			const idKey = "player-check-item-" + idx + "-" + idPostfix;
			let checked = self.isChecked(item.value, choiceItem.value);

			//add dynamic styles if present
			if (choiceItem.properties && choiceItem.properties !== "") {
				let properties = choiceItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(choiceItem, propertiesObject);
			}
			let inputSize = 30; // use default
			if (choiceItem.style) {
				choiceItem.style.justifyContent = choiceItem.style.textAlign === "right" ? "flex-end" : "flex-start";
				inputSize = choiceItem.style.inputSize ? choiceItem.style.inputSize : 30;
			} else {
				choiceItem.style = {};
			}

			//should have default theme specific to show mode
			if (_.isUndefined(choiceItem.style.fontSize)) {
				choiceItem.style.fontSize = "18px";
			}

			if (_.isUndefined(choiceItem.style.color)) {
				choiceItem.style.color = "#FFFFFF";
			}

			if (_.isUndefined(choiceItem.style.textAlign)) {
				choiceItem.style.textAlign = "left";
			}

			return (
				<PlayerCheckbox size={inputSize} key={idKey} id={idKey} checked={checked} onClick={(e) => self.onClick(e, choiceItem.value, choiceItem.label)} label={choiceItem.label} disabled={disabled} style={choiceItem.style} />
			);
		});

		let rowsContainer = <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px", marginTop: "12px" }}>
			{rows}
		</div>;

		return (<div style={{
			display: "flex", flexDirection: "column", width: "100%", height: "100%", backgroundImage: backgroundImage, backgroundPosition: "center", backgroundSize: "cover", backgroundRepeat: "noRepeat"
		}}>
			<div style={{ display: "flex", width: "100%", height: "100%", padding: "20px 50px 40px 50px", boxSizing: "border-box" }}>
				<div className="player-show-mode-view" style={{ width: "100%", height: "100%", overflow: "none", display: "flex", position: "relative" }}>

					{hasTextContent && <div className={`player-show-mode-label-item-container${align}`}>
						{getLabelsShowMode()}
						{rowsContainer}
					</div>}
					{mediaItem && <div className="player-show-mode-media-item-container">
						<div>{mediaItem}</div>
					</div>}
				</div>
			</div>
		</div>);
	}
}

export default withPlayerItemHoc(PlayerMultiChoice);